import type { MutableRefObject, RefObject } from 'react';
import React, { useEffect } from 'react';

import { sendLog } from '@/lib/utils/send-log';

import * as S from './SectionTitleBar.style';
const titles = ['웨비나 소개', '연사', '상세 내용'];
type SectionTitleBarProps = {
  refs: MutableRefObject<RefObject<HTMLElement>[]>;
};

const SectionTitleBar = ({ refs }: SectionTitleBarProps) => {
  const [target, setTarget] = React.useState(0);
  useEffect(() => {
    const onScroll = () => {
      const idx = refs.current.findIndex((ref) => {
        if (!ref.current) {
          return false;
        }
        const { bottom } = ref.current.getBoundingClientRect();
        return bottom > 40;
      });
      setTarget(idx);
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [refs]);

  const onClickHandler = (e: React.MouseEvent<HTMLDivElement>, idx: number) => {
    const ref = refs.current[idx];
    const { top } = ref.current.getBoundingClientRect();
    window.scrollBy({
      top: top - 160,
      behavior: 'smooth',
    });
  };
  return (
    <>
      <S.MobileDivider />
      <S.Container>
        <S.SectionTitles>
          {titles.map((title, idx) => (
            <S.SectionTitle
              key={idx}
              selected={target === idx}
              onClick={(e) => {
                sendLog('hh_webinarDetailPage_lnb_click', {
                  button_text: title,
                });
                onClickHandler(e, idx);
              }}
            >
              {title}
            </S.SectionTitle>
          ))}
        </S.SectionTitles>
      </S.Container>
    </>
  );
};
export default SectionTitleBar;
